module.exports = "/work-site/img/login-image.6379c43e.png";